"use strict";var Le=Object.create;var H=Object.defineProperty;var Fe=Object.getOwnPropertyDescriptor;var Re=Object.getOwnPropertyNames;var Me=Object.getPrototypeOf,ze=Object.prototype.hasOwnProperty;var Ee=(o,t)=>{for(var r in t)H(o,r,{get:t[r],enumerable:!0})},j=(o,t,r,s)=>{if(t&&typeof t=="object"||typeof t=="function")for(let l of Re(t))!ze.call(o,l)&&l!==r&&H(o,l,{get:()=>t[l],enumerable:!(s=Fe(t,l))||s.enumerable});return o};var v=(o,t,r)=>(r=o!=null?Le(Me(o)):{},j(t||!o||!o.__esModule?H(r,"default",{value:o,enumerable:!0}):r,o)),$e=o=>j(H({},"__esModule",{value:!0}),o);var Oe={};Ee(Oe,{BlankNavigation:()=>Q,MainNavigation:()=>X,SettingsNavigation:()=>Y,isTrialAccount:()=>Se});module.exports=$e(Oe);var qo=require("@fortawesome/pro-solid-svg-icons/faTableList"),Zo=require("@fortawesome/pro-solid-svg-icons/faMap"),Xo=require("@fortawesome/pro-solid-svg-icons/faFlask"),Yo=require("@fortawesome/pro-solid-svg-icons/faThumbtack"),Qo=require("@fortawesome/pro-solid-svg-icons/faCheckCircle"),jo=require("@fortawesome/pro-solid-svg-icons/faCommentAlt"),oe=require("@fortawesome/pro-solid-svg-icons/faArrowsTurnToDots"),ee=require("@fortawesome/pro-solid-svg-icons/faProjectDiagram"),te=require("@fortawesome/pro-solid-svg-icons/faChartColumn"),re=require("@fortawesome/pro-solid-svg-icons/faRocket"),ae=require("@fortawesome/pro-solid-svg-icons/faTh"),ne=require("@fortawesome/pro-solid-svg-icons/faPalette"),ie=require("@fortawesome/pro-solid-svg-icons/faUsers"),se=require("@fortawesome/pro-solid-svg-icons/faBullseye"),ce=require("@fortawesome/pro-solid-svg-icons/faFlag"),le=require("@fortawesome/pro-solid-svg-icons/faCode");var I=require("@appcues/sonar"),eo=require("react-hook-form");var x=require("@appcues/sonar"),W=v(require("styled-components")),Be=W.css`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
`,oo=(0,W.default)(x.Form)`
  padding: var(--spacing-regular);
  padding-bottom: 0;

  ${x.Button} {
    flex: 1;
  }

  ${x.Input} {
    flex: 2;
    ${Be};
  }

  ${x.InlineMessage} {
    padding-top: var(--spacing-small);
  }
`;var A=require("react/jsx-runtime"),U=({user:o,isSpoofing:t,onSpoof:r})=>{let{register:s,handleSubmit:l,formState:{errors:g,isSubmitting:n},setError:u}=(0,eo.useForm)(),{isAdmin:d}=o!=null?o:{};return!d||t?null:(0,A.jsxs)(oo,{onSubmit:l(async({accountId:f})=>{try{await r(f)}catch(B){u("accountId",{message:"Failed to spoof"})}}),children:[(0,A.jsxs)(I.Row,{xAlign:"center",spacing:"small",children:[(0,A.jsx)(I.Input,{id:"accountId",placeholder:"Account ID",type:"number",...s("accountId",{required:"Can't be empty"})}),(0,A.jsx)(I.Button,{type:"submit",disabled:n,children:"Spoof"})]}),g.accountId&&(0,A.jsx)(I.InlineMessage,{variant:"error",children:g.accountId.message})]})};var _=v(require("styled-components")),to=_.default.header`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: var(--spacing-large);
  padding-top: var(--spacing-large);
`,ro=_.default.span`
  align-items: center;
  color: var(--color-blurple-600);
  display: flex;
  font-size: var(--icon-size-large);
  justify-content: center;

  svg {
    height: 30px;
    width: 24px;

    path {
      fill: currentColor;
    }
  }
`;var L=require("react/jsx-runtime"),F=()=>(0,L.jsx)(to,{children:(0,L.jsx)("a",{href:"/",children:(0,L.jsx)(ro,{children:(0,L.jsx)("svg",{viewBox:"0 0 1600 2000",xmlns:"http://www.w3.org/2000/svg",role:"img","aria-label":"Appcues logo",children:(0,L.jsx)("path",{d:"M695.6 1083.4l555.9 870.5c14.1 21.2 35.3 31 60.7 31h206c39.5 0 70.5-31 70.5-70.5V70.4c0-66.3-83.2-95.9-127-43.7L695.6 998.8c-16.9 22.6-16.9 57.8 0 84.6zM70.6 1985h366.8c39.5 0 70.5-31 70.5-70.5V1446c0-66.3-83.2-95.9-127-43.7L14.1 1870.7c-35.2 48 0 114.3 56.5 114.3z"})})})})});var R=v(require("styled-components")),ao=require("@appcues/sonar"),no=(0,R.default)(ao.Stack).attrs({spacing:"none"})`
  position: fixed;
  bottom: 0;
  left: 0;
  top: 0;
  width: 216px;
  background-color: var(--color-neutral-0);
  border-right: 1px solid var(--border-default);
  display: flex;
  flex-direction: column;
  /*
  * This z-index is chosen because it is bigger than the biggest z-index currently
  * found in studio excluding Modals, which is in the studio classic TabsRoot
  * component (z-index: 3000). We will look at standardizing our use of z-index in
  * studio in the future.
  */
  z-index: 4000;
`,io=R.default.div`
  overflow-y: auto;
  flex-grow: 1;
`,so=R.default.nav`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`,co=R.default.ul`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);
  padding-bottom: var(--spacing-small);
  padding-top: var(--spacing-small);
  list-style-type: none;
`;var C=require("@appcues/sonar");var lo=v(require("styled-components")),po=require("@appcues/sonar"),mo=lo.default.li`
  a {
    height: 40px;
    display: flex;
    text-decoration: none;
    padding-left: var(--spacing-large);
    transition: background-color 0.3s ease;

    svg {
      display: block;
      // We use 18px because the banners icon requires a width of 18px
      width: 18px;

      path {
        transition: fill 0.3s ease;
      }
    }
    &.active {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      ${po.Text} {
        font-weight: var(--font-weight-bold);
      }

      svg path {
        fill: var(--color-blurple-600);
      }
    }

    :hover {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      svg path {
        fill: var(--color-blurple-600);
      }
    }
  }
`;var k=require("react/jsx-runtime"),go=({children:o,icon:t,iconElement:r,NavLink:s,to:l,exact:g})=>(0,k.jsx)(mo,{children:(0,k.jsx)(s,{to:l,exact:g,children:(0,k.jsxs)(C.Row,{spacing:"small",yAlign:"center",children:[r&&r,t&&(0,k.jsx)(C.Icon,{icon:t,colorToken:"color-neutral-700",size:"small"}),(0,k.jsx)(C.Text,{children:o})]})})});var Io=require("react"),V=require("@appcues/sonar");var S=require("@appcues/sonar"),h=v(require("styled-components")),K=h.css`
  fill: var(--color-blurple-600);
`,J=(0,h.default)(S.Icon)`
  display: block;
  // 18px is used so that the accordion icon aligns with the other nav item icons
  width: 18px;

  path {
    transition: fill 0.3s ease;
    // The active state is determined programatically because when the accordion is closed the active list item is reomved from the DOM
    ${({$isActive:o})=>o&&K}
  }
`,vo=h.css`
  background-color: var(--color-neutral-50);
  border-radius: var(--border-radius-small);
`,uo=(0,h.default)(S.Accordion.Header)`
  height: 40px;
  display: flex;
  // The Sonar Accordion.Header has some padding that we need to override so that the correct hover background can be applied
  padding: 0;
  font-weight: var(--font-weight-regular);
  transition: background-color 0.3s ease;

  :hover {
    ${vo};

    ${J} {
      path {
        ${K};
      }
    }
  }

  /* Shows accordion header as active if collapsed */
  &[data-state='closed'] {
    ${({$isActive:o})=>o&&vo};
  }
`,fo=(0,h.default)(S.Accordion.Trigger)`
  color: var(--foreground-secondary);
  padding-left: var(--spacing-large);
  padding-right: var(--spacing-regular);
`,ho=(0,h.default)(S.Accordion.Content)`
  p {
    // Padding of 26px is required so that the accordion content aligns correctly with the other nav item text
    padding-left: 26px;
  }

  // We don't want padding on the last list item because a 4px space is already provided by the flex gap
  li {
    &:not(:last-child) {
      padding-bottom: var(--spacing-x-small);
    }
  }
`,No=(0,h.default)(S.Accordion.Item)`
  // These styles create a gap between the trigger and the content when the accordion is expanded, but
  // the gap is removed when the accordion is collapsed
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);

  // This selector is used to apply the blurple fill to the accordion icon when one of it's children is hovered
  &:has(div > li > a:hover) {
    div > svg > path {
      ${K}
    }
  }
`;var b=require("react/jsx-runtime"),He="@navigation/accordion_",xo={getAccordionKey(o){return`${He}${o}`},getAccordionValue(o){let t=this.getAccordionKey(o);return localStorage.getItem(t)},setAccordionValue(o,t){let r=this.getAccordionKey(o);Boolean(t)?localStorage.setItem(r,t):localStorage.removeItem(r)}},bo=({children:o,text:t,icon:r,isActive:s})=>{let l=()=>{if(s)return t;let d=xo.getAccordionValue(t);if(d)return d},[g,n]=(0,Io.useState)(l()),u=d=>{n(d),xo.setAccordionValue(t,d)};return(0,b.jsx)(V.Accordion.Root,{collapsible:!0,value:g,onValueChange:u,type:"single",unstyled:!0,children:(0,b.jsxs)(No,{value:t,children:[(0,b.jsx)(uo,{$isActive:s,children:(0,b.jsx)(fo,{children:(0,b.jsxs)(V.Row,{spacing:"small",yAlign:"center",children:[(0,b.jsx)(J,{icon:r,colorToken:"color-neutral-700",size:"small",$isActive:s}),t]})})}),(0,b.jsx)(ho,{children:o})]})})};var e={Wrapper:no,ScrollContainer:io,NavList:co,Nav:so,NavItem:go,NavAccordion:bo};var yo=require("react/jsx-runtime"),q=()=>(0,yo.jsx)("svg",{width:"18",height:"16",viewBox:"0 0 18 16",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:(0,yo.jsx)("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M17.1258 5L14.902 8.00085L17.1246 11H1.1258L3.34967 7.99915L1.12706 5H17.1258ZM0.874146 11H0.874181L0.874181 5H0.874146V11Z",fill:"var(--color-neutral-600)"})});var Do=require("@fortawesome/pro-solid-svg-icons/faGear"),Go=require("@fortawesome/pro-solid-svg-icons/faChevronRight"),Oo=require("@fortawesome/pro-solid-svg-icons/faExternalLink"),Uo=require("@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket"),z=require("@appcues/sonar"),_o=require("react");var N=v(require("styled-components")),m=require("@radix-ui/react-dropdown-menu"),wo=(0,N.default)(m.Content)`
  background-color: var(--color-neutral-0);
  border-radius: var(--border-radius-small);
  box-shadow: var(--elevation-100);
  width: 235px;
`,So=(0,N.default)(m.Label)`
  color: var(--foreground-secondary);
  font-weight: var(--font-weight-bold);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: var(--spacing-small) var(--spacing-regular);
  font-size: var(--font-size-medium);
  cursor: default;
`,To=(0,N.default)(m.Group)`
  padding: var(--spacing-small) var(--spacing-x-small);
`,Ao=(0,N.default)(m.Separator)`
  border-bottom: 0;
  border-top: 1px solid var(--border-default);
`,ko=(0,N.default)(m.Trigger)`
  &:focus-visible {
    outline-width: 0px;
  }
`,Co=(0,N.default)(m.CheckboxItem)``,Po=(0,N.default)(m.Root)``,Lo=(0,N.default)(m.Portal)``;var M=require("@appcues/sonar"),zo=require("@radix-ui/react-dropdown-menu");var Fo=require("@appcues/sonar"),Ro=v(require("styled-components")),Mo=Ro.default.div`
  display: block;
  text-decoration: none;
  padding: var(--spacing-small) var(--spacing-regular);
  cursor: pointer;

  :hover {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);
  }

  ${Fo.Text} {
    flex: 1;
  }

  :focus-visible {
    outline: none;
  }
`;var P=require("react/jsx-runtime"),Eo=({title:o,icon:t=null,onClick:r,children:s,...l})=>(0,P.jsx)(zo.Item,{asChild:!0,onSelect:r,children:(0,P.jsxs)(Mo,{...l,children:[o&&(0,P.jsx)(M.Text,{size:"regular",weight:"bold",children:o}),(0,P.jsxs)(M.Row,{yAlign:"center",children:[(0,P.jsx)(M.Text,{children:s}),t]})]})});var p={Root:Po,CheckboxItem:Co,Content:wo,Heading:So,Item:Eo,Section:To,Separator:Ao,Trigger:ko,Portal:Lo};var y=require("@appcues/sonar"),T=v(require("styled-components")),$o=T.default.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${y.Icon} {
    transition: color 0.2s ease;
  }
`,D=(0,T.default)($o)`
  grid-area: left-icon;
  margin-right: var(--spacing-small);
`,Bo=(0,T.default)($o)`
  grid-area: right-icon;
`,Ho=(0,T.default)(y.Text)`
  grid-area: company-name;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`,Wo=(0,T.default)(y.Text)`
  grid-area: user-name;
`,Vo=T.default.div`
  width: 100%;
  display: grid;
  padding: var(--spacing-regular) var(--spacing-large);
  grid-template-areas:
    'left-icon  company-name  right-icon'
    '.          user-name     .';
  grid-template-columns: min-content 1fr min-content;
  transition: background-color 0.3s ease;

  ${y.Text} {
    flex: 1;
  }

  :hover {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    ${D} > ${y.Icon} {
      color: var(--color-blurple-600);
    }
  }

  &[data-state='open'] {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    ${D} > ${y.Icon} {
      color: var(--color-blurple-600);
    }
  }
`;var i=require("react/jsx-runtime"),Z=({NavLink:o,onLogout:t,user:r,account:s,accountsCount:l})=>{let[g,n]=(0,_o.useState)(!1),u=(r==null?void 0:r.fullName)||(r==null?void 0:r.fullname),{name:d}=s!=null?s:{},{email:$}=r!=null?r:{},f=d||$||"",B=()=>n(O=>!O);return(0,i.jsxs)(p.Root,{onOpenChange:B,open:g,modal:!1,children:[(0,i.jsx)(p.Trigger,{asChild:!0,children:(0,i.jsxs)(Vo,{role:"button",title:`${u} (${f})`,children:[(0,i.jsx)(D,{children:(0,i.jsx)(z.Icon,{icon:Do.faGear,colorToken:"foreground-secondary",size:"small"})}),(0,i.jsx)(Ho,{weight:"bold",children:f}),(0,i.jsx)(Bo,{children:(0,i.jsx)(z.Icon,{icon:Go.faChevronRight,colorToken:"foreground-secondary",size:"small"})}),u&&(0,i.jsx)(Wo,{size:"small",children:u})]})}),(0,i.jsx)(p.Portal,{children:(0,i.jsxs)(p.Content,{align:"end",side:"right",sideOffset:8,alignOffset:8,children:[l>1?(0,i.jsx)(p.Section,{children:(0,i.jsx)(p.Item,{title:f,as:o,to:"/accounts",children:"Switch Accounts"})}):(0,i.jsx)(p.Section,{children:(0,i.jsx)(p.Heading,{title:f,children:f})}),(0,i.jsx)(p.Separator,{}),(0,i.jsxs)(p.Section,{children:[(0,i.jsx)(p.Item,{as:o,to:"/settings/account",children:"Settings"}),(0,i.jsx)(p.Item,{as:o,to:"/diagnostics",children:"Diagnostics"}),(0,i.jsx)(p.Item,{as:"a",href:"https://status.appcues.com",target:"_blank",icon:(0,i.jsx)(z.Icon,{icon:Oo.faExternalLink,colorToken:"foreground-link",size:"small"}),children:"Appcues status"})]}),(0,i.jsx)(p.Separator,{}),(0,i.jsx)(p.Section,{children:(0,i.jsx)(p.Item,{onClick:t,forwardedAs:o,icon:(0,i.jsx)(z.Icon,{icon:Uo.faArrowRightFromBracket,colorToken:"foreground-secondary",size:"small"}),children:"Sign Out"})})]})})]})};var Ko=v(require("styled-components")),Jo=require("@radix-ui/react-separator"),E=(0,Ko.default)(Jo.Separator)`
  height: 1px;
  background: var(--border-default);
  margin: 0px var(--spacing-regular);
`;var a=require("react/jsx-runtime"),X=({user:o,account:t,accountsCount:r,onSpoof:s,onLogout:l,isSpoofing:g,NavLink:n,featureFlags:u,matchExactRoutes:d})=>{let{hasPins:$,hasExperiments:f,hasDevTools:B,hasApiPlayground:O,hasJourneys:Te,hasBanners:Ae,hasLaunchpads:ke,hasS5GroupList:Ce,hasWorkflows:Pe}=u;return(0,a.jsxs)(e.Wrapper,{children:[(0,a.jsx)(U,{user:o,onSpoof:s,isSpoofing:g}),(0,a.jsx)(F,{}),(0,a.jsx)(e.ScrollContainer,{children:(0,a.jsxs)(e.Nav,{children:[(0,a.jsxs)(e.NavList,{children:[(0,a.jsx)(e.NavItem,{icon:qo.faTableList,NavLink:n,to:"/",exact:d,children:"Overview"}),(0,a.jsx)(e.NavItem,{icon:Zo.faMap,NavLink:n,to:"/flows",children:"Flows"}),$&&(0,a.jsx)(e.NavItem,{icon:Yo.faThumbtack,NavLink:n,to:"/pins",children:"Pins"}),Ae&&(0,a.jsx)(e.NavItem,{iconElement:(0,a.jsx)(q,{}),NavLink:n,to:"/banners",children:"Banners"}),(0,a.jsx)(e.NavItem,{icon:Qo.faCheckCircle,NavLink:n,to:"/checklists",children:"Checklists"}),ke&&(0,a.jsx)(e.NavItem,{icon:re.faRocket,NavLink:n,to:"/launchpads",children:"Launchpads"}),(0,a.jsx)(e.NavItem,{icon:jo.faCommentAlt,NavLink:n,to:"/nps",children:"NPS"})]}),(0,a.jsx)(E,{}),(0,a.jsxs)(e.NavList,{children:[Pe&&(0,a.jsx)(e.NavItem,{icon:oe.faArrowsTurnToDots,NavLink:n,to:"/workflows",children:"Workflows"}),f&&(0,a.jsx)(e.NavItem,{icon:Xo.faFlask,NavLink:n,to:"/experiments",children:"Experiments"}),(0,a.jsx)(e.NavItem,{icon:te.faChartColumn,NavLink:n,to:"/insights/explorer",children:"Events Explorer"}),(0,a.jsx)(e.NavItem,{icon:ae.faTh,NavLink:n,to:"/insights/charts",children:"Saved Charts"}),Te&&(0,a.jsx)(e.NavItem,{icon:ee.faProjectDiagram,NavLink:n,to:"/journeys",children:"Journeys"})]}),(0,a.jsx)(E,{}),(0,a.jsxs)(e.NavList,{children:[(0,a.jsx)(e.NavItem,{icon:ne.faPalette,NavLink:n,to:"/themes",children:"Themes"}),(0,a.jsx)(e.NavItem,{icon:ie.faUsers,NavLink:n,to:"/audience/segments",children:Ce?"Audiences":"Segments & Users"}),(0,a.jsx)(e.NavItem,{icon:se.faBullseye,NavLink:n,to:"/goals",children:"Goals"})]}),(0,a.jsx)(E,{}),(0,a.jsxs)(e.NavList,{children:[B&&(0,a.jsx)(e.NavItem,{icon:ce.faFlag,NavLink:n,to:"/dev-tools",children:"Dev Tools"}),O&&(0,a.jsx)(e.NavItem,{icon:le.faCode,NavLink:n,to:"/api-playground",children:"API Playground"})]})]})}),(0,a.jsx)(E,{}),(0,a.jsx)(Z,{user:o,account:t,NavLink:n,accountsCount:r,onLogout:l})]})};var ue=require("@fortawesome/pro-solid-svg-icons/faCircleUser"),fe=require("@fortawesome/pro-solid-svg-icons/faPeopleGroup"),he=require("@fortawesome/pro-regular-svg-icons/faCreditCard"),Ne=require("@fortawesome/pro-solid-svg-icons/faLaptopMobile"),xe=require("@fortawesome/pro-solid-svg-icons/faPlug"),Ie=require("@fortawesome/pro-solid-svg-icons/faDatabase"),be=require("@fortawesome/pro-solid-svg-icons/faGlobe");var pe=require("@appcues/sonar"),me=v(require("styled-components")),de=(0,me.default)(pe.Text)`
  padding-left: var(--spacing-large);
  padding-top: var(--spacing-regular);
  padding-bottom: var(--spacing-regular);
`;var w=require("@appcues/sonar"),ge=v(require("styled-components")),G=require("react/jsx-runtime"),We=(0,ge.default)(w.Button)`
  position: absolute;
  top: 20px;
  left: 32px;
`,ve=({onClick:o})=>(0,G.jsx)(We,{variant:"tertiary",iconOnly:!0,onClick:o,children:(0,G.jsx)(w.Tooltip,{content:(0,G.jsx)(w.Text,{size:"small",lineHeight:"large",colorToken:"foreground-tooltip",children:"Exit settings"}),placement:"bottom",children:(0,G.jsx)(w.Icon,{icon:"chevron-left"})})});var c=require("react/jsx-runtime"),Ve=new Set(["/settings/integrations","/webhooks","/settings/keys","/integrations/webhooks","/integrations/connections"]),De=new Set(["/settings/events","/settings/properties"]),Y=({NavLink:o,featureFlags:t,onClickBackArrow:r,currentPath:s})=>{let{hasFlowLocalization:l,hasIntegrationPageRedesign:g,hasMobileFlows:n}=t,u=Ve.has(s),d=De.has(s);return(0,c.jsxs)(e.Wrapper,{children:[(0,c.jsx)(ve,{onClick:r}),(0,c.jsx)(F,{}),(0,c.jsx)(de,{size:"medium",weight:"semibold",children:"Settings"}),(0,c.jsx)(e.ScrollContainer,{children:(0,c.jsx)(e.Nav,{children:(0,c.jsxs)(e.NavList,{children:[(0,c.jsx)(e.NavItem,{icon:ue.faCircleUser,NavLink:o,to:"/settings/account",children:"Profile"}),(0,c.jsx)(e.NavItem,{icon:fe.faPeopleGroup,NavLink:o,to:"/settings/team",children:"Team"}),(0,c.jsx)(e.NavItem,{icon:he.faCreditCard,NavLink:o,to:"/settings/subscription",children:"Subscription"}),(0,c.jsx)(e.NavItem,{icon:Ne.faLaptopMobile,NavLink:o,to:"/settings/installation",children:n?"Apps & Installation":"Installation"}),(0,c.jsxs)(e.NavAccordion,{text:"Integrations",icon:xe.faPlug,isActive:u,children:[(0,c.jsx)(e.NavItem,{NavLink:o,to:g?"/integrations/connections":"/settings/integrations",children:"Connections"}),(0,c.jsx)(e.NavItem,{NavLink:o,to:"/integrations/webhooks",children:"Webhooks"}),(0,c.jsx)(e.NavItem,{NavLink:o,to:"/settings/keys",children:"API Keys"})]}),(0,c.jsxs)(e.NavAccordion,{text:"Data",icon:Ie.faDatabase,isActive:d,children:[(0,c.jsx)(e.NavItem,{NavLink:o,to:"/settings/events",children:"Events"}),(0,c.jsx)(e.NavItem,{NavLink:o,to:"/settings/events",children:"Properties"})]}),l&&(0,c.jsx)(e.NavItem,{icon:be.faGlobe,NavLink:o,to:"/settings/localization",children:"Localization"})]})})})]})};var ye=v(require("styled-components")),we=ye.default.div`
  flex: 0 0 216px;
  width: 216px;
  position: fixed;
  height: 100vh;
  background-color: var(--color-neutral-100);
  border-right: 1px solid var(--border-default);
  bottom: 0;
  left: 0;
  top: 0;
  z-index: 100;
`;var Ge=require("react/jsx-runtime"),Q=()=>(0,Ge.jsx)(we,{});var Se=(o,t)=>!((o==null?void 0:o.stripePlanId)||(t==null?void 0:t.isExpired));0&&(module.exports={BlankNavigation,MainNavigation,SettingsNavigation,isTrialAccount});
//# sourceMappingURL=index.js.map